function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1071 1182",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,861.886l425.641,-0l-57.75,319.216l-367.891,-319.216Z",
    style: {
      fill: "#767679",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.587,434.745c-8.085,37.83 -18.372,80.593 -25.938,107.992c-33.648,-0.096 -194.737,-0.231 -317.236,-0.385l46.339,-205.869l218.877,2.845c0,0 98.657,-1.442 77.958,95.417Zm-17.526,-434.745l-538.439,0l-93.706,413.547l1.673,-0l-101.589,448.339l962.466,-0l99.925,-448.339c48.002,-211.888 -113.068,-413.547 -330.33,-413.547Z",
    style: {
      fill: "#0dc1f2",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.cfe22bf93e53703055fd52bd6c7fd889.svg";
export { ForwardRef as ReactComponent };